import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const NameDrivers = (props) => {
  return (
    <FormGroup controlId="nameDrivers">
      <Col componentClass={ControlLabel} sm={5}>
        Named Drivers
      </Col>
    <Col sm={7}>
          <textarea
              id="nameDrivers"
              rows="6"
              cols="50"
              maxLength="4000"
              value={props.nameDrivers}
              onChange={props.handleChangeNameDrivers}
            />
    </Col>
    </FormGroup>
  )
}

NameDrivers.propTypes = {
  nameDrivers: PropTypes.string,
  handleChangeNameDrivers: PropTypes.func,

};

export default NameDrivers;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/nameDrivers/NameDrivers.js